// externals
import * as React from 'react';

// libraries
import { dateUtils } from '@makemydeal/dr-common-utils';

// utils
import * as textFormatUtil from './textFormatUtil';

// icons
import { CheckmarkHollowIcon } from '../../icons/CheckmarkHollowIcon';
import { CheckmarkIcon } from '../../icons/CheckmarkIcon';

export interface IActivityStatusItemStateProps {
    className: string;
    completionDate: Date | undefined;
    errorMessage?: string;
    statusText: string;
    hideSubText?: boolean;
}

export interface IActivityStatusItemDispatchProps {}

export type ActivityStatusItemProps = IActivityStatusItemStateProps & IActivityStatusItemDispatchProps;

const getClassName = (props: ActivityStatusItemProps) => {
    const { className, completionDate, errorMessage } = props;
    let result = 'dr-ui-activity-status-item';
    if (completionDate && !errorMessage) {
        result += ' dr-ui-activity-complete';
    }
    if (className) {
        result += ` ${className}`;
    }
    return result;
};

const getFormattedStatusText = (props: ActivityStatusItemProps) => {
    const innerHtml = {
        __html: textFormatUtil.formatSimpleMarkdownAsHtml(props.statusText)
    };
    const result = <div className="dr-ui-activity-status-text" dangerouslySetInnerHTML={innerHtml}></div>;
    return result;
};

const getFormattedStatusSubText = (props: ActivityStatusItemProps) => {
    const { completionDate, errorMessage } = props;
    let formattedStatusSubText = null;
    if (errorMessage) {
        formattedStatusSubText = <div className="dr-ui-activity-status-sub-text-error">{errorMessage}</div>;
    } else if (completionDate) {
        const dateFormatted = dateUtils.formatAsMMDDYYYY(completionDate);
        const timeFormatted = dateUtils.formatAsTime(completionDate);
        formattedStatusSubText = <div className="dr-ui-activity-status-sub-text">{`${dateFormatted} at ${timeFormatted}`}</div>;
    }
    return formattedStatusSubText;
};

const ActivityStatusItemUI: React.FC<ActivityStatusItemProps> = (props) => {
    const icon = props.completionDate ? <CheckmarkIcon /> : <CheckmarkHollowIcon />;
    return (
        <div className={getClassName(props)}>
            <div className="dr-ui-activity-status-icon">{icon}</div>
            <div className="dr-ui-activity-status-content">
                {getFormattedStatusText(props)}
                {props && props.hideSubText ? null : getFormattedStatusSubText(props)}
            </div>
        </div>
    );
};

export default ActivityStatusItemUI;
